// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Fixed_wrapper__1pLSu"};